import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import { store } from "../store";



export function GetDistricts() {

  const { dispatch } = store;
  CommonAxiosGet(config.url.FAC_URL + "getdistricts").then((res) => {
    if (res !== undefined) {

      dispatch({ type: "DISTRICTLIST", payload: res?.data?.districtmst });

      return dispatch({ type: "DISTRICTLIST", payload: res?.data?.districtmst });
    }
  })
}



export const getMandals = (distCode, dispatch, targetField) => {
  if (distCode === undefined || distCode === "" || distCode === null) {
    dispatch({ type: "MANDALSLIST", payload: [] });
    dispatch({ type: "VILLAGESLIST", payload: [] });

  } else {

    CommonAxiosGet(config.url.FAC_URL + "getmandals/" + distCode).then((res) => {
      if (res !== undefined) {
        if (targetField === "societyHeadDist") {
          dispatch({ type: "MANDALSLIST_MultiField", payload: res.data.mandalmst });
        }
        else {
          dispatch({ type: "MANDALSLIST", payload: res.data.mandalmst });
        }

      }
      else {
        if (targetField === "societyHeadDist") {
          dispatch({ type: "MANDALSLIST_MultiField", payload: [] });
        }
        else {
          dispatch({ type: "MANDALSLIST", payload: [] });
          dispatch({ type: "VILLAGESLIST", payload: [] });

        }

      }
    });
  }
}



// ............................................

export const GetNocServices = () => {
  const { dispatch } = store;
  dispatch({ type: 'SHOW_SPINNER', payload: true });
  const url = `${config.url.FAC_URL}getnocservicesmst`
  CommonAxiosGet(url).then((res) => {
    console.log("GetNocServices>>", res);
    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    if (res !== undefined) {
      console.log("GetNocServices>else>", res?.data?.noc_services);
      dispatch({ type: "NOC_SERVICES", payload: res?.data?.noc_services });
    }
  })
}

export const GetScrutinyInputDetails = (collCode) => {
  const { dispatch } = store;
  if (!collCode) {
    dispatch({ type: "GET_SCRUTINY_INPUT_DETAILS", payload: null });
    return;
  }
  const url = `${config.url.FAC_URL}getInputDetails/NameChange/${collCode}`;
  CommonAxiosGet(url)
    .then((res) => {
      dispatch({ type: "GET_SCRUTINY_INPUT_DETAILS", payload: res?.data || null });
    })
    .catch(() => {
      dispatch({ type: "GET_SCRUTINY_INPUT_DETAILS", payload: null });
    });
};

export const GetScrutinyCollegeDetails = (collCode, nocType) => {
  const { dispatch } = store;
  if (!collCode || !nocType) {
    dispatch({ type: "GET_SCRUTINY_COLLEGE_DETAILS", payload: null });
    return;
  }
  const url = `${config.url.FAC_URL}getScrutinyDetails/${collCode}/${nocType}`;
  CommonAxiosGet(url)
    .then((res) => {
      dispatch({ type: "GET_SCRUTINY_COLLEGE_DETAILS", payload: res?.data || null });
    })
    .catch(() => {
      dispatch({ type: "GET_SCRUTINY_COLLEGE_DETAILS", payload: null });
    });
};

export const GetScrutinyAccommodation = (collCode) => {
  const { dispatch } = store;
  if (!collCode) {
    dispatch({ type: "GET_SCRUTINY_ACCOMMODATION", payload: [] });
    return;
  }
  const url = `${config.url.FAC_URL}getAccommodationAreaData/${collCode}`;
  CommonAxiosGet(url)
    .then((res) => {
      const payload = res?.data?.status === true ? res?.data?.data || [] : [];
      dispatch({ type: "GET_SCRUTINY_ACCOMMODATION", payload });
    })
    .catch(() => {
      dispatch({ type: "GET_SCRUTINY_ACCOMMODATION", payload: [] });
    });
};

export const GetCoursesScrutinyList = (collCode) => {
  const { dispatch } = store;
  if (!collCode) {
    dispatch({ type: "GET_COURSES_SCRUTINY_LIST", payload: [] });
    return;
  }
  const url = `${config.url.FAC_URL}getCoursescrutinylist/${collCode}`;
  CommonAxiosGet(url)
    .then((res) => {
      const payload = res?.data?.status === true ? res?.data?.courseslist || [] : [];
      dispatch({ type: "GET_COURSES_SCRUTINY_LIST", payload });
    })
    .catch(() => {
      dispatch({ type: "GET_COURSES_SCRUTINY_LIST", payload: [] });
    });
};

export const GetConversionScrutinySavedDetails = (collCode) => {
  const { dispatch } = store;
  if (!collCode) {
    dispatch({ type: "CONVERSION_SCRUTINY_SAVED_DETAILS", payload: null });
    return;
  }
  const url = `${config.url.FAC_URL}getConversionScrutiny/${collCode}`;
  CommonAxiosGet(url)
    .then((res) => {
      dispatch({ type: "CONVERSION_SCRUTINY_SAVED_DETAILS", payload: res?.data || null });
    })
    .catch(() => {
      dispatch({ type: "CONVERSION_SCRUTINY_SAVED_DETAILS", payload: null });
    });
};


export const DashBoardCounts = (type) => {
  const { dispatch } = store;
  if (!type) {
    dispatch({ type: "DASHBOARD_COUNTS", payload: null });
    return;
  }

  const url = `${config.url.FAC_URL}getFinalStatusCount?nocType=${type}`;
  CommonAxiosGet(url)
    .then((res) => {
      dispatch({ type: "DASHBOARD_COUNTS", payload: res?.data?.data || null });
    })
    .catch(() => {
      dispatch({ type: "DASHBOARD_COUNTS", payload: null });
    });
};



